// extracted by mini-css-extract-plugin
module.exports = {"missingImgStrip":"UserTipStrip_missingImgStrip__2Hgzu","inlineLink":"UserTipStrip_inlineLink__2szUl","blupIcon":"UserTipStrip_blupIcon__mxWK3"};